import React from "react";

class DateRangeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("DateRangePicker Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ color: "red", fontSize: "14px" }}>
          Something went wrong while loading the date picker.
        </div>
      );
    }

    return this.props.children;
  }
}

export default DateRangeErrorBoundary;
